<template>
    <div>
        <p v-for="error in errors.collect(question.id)" :key="error" class="errorText">
            {{ error }}
        </p>
        <input 
            type="text" 
            v-model="itemValue.value" 
            v-validate="{rules: {'required': question.required, 'email': true, 'free_email': [origEmail]}}"
            data-vv-delay="200"
            :name="question.id" 
            :class="{'error': errors.has(question.id)}"
            :id="question.id">
    </div>
</template>
<script>
    import { Validator } from 'vee-validate';

    Validator.extend('free_email', (value, [origEmail]) =>  value === origEmail ? true : jQuery.ajax(
                    {
                        url: '/profile/email/validate',
                        type: 'POST',
                        dataType: 'json',
                        data: JSON.stringify(value),
                        contentType: "application/json; charset=utf-8"
                    }).then((response) => {
                        return { 
                            valid: response, 
                            data: {}
                        };
                    }));

	export default {
		name: 'profileEmailEditor',
		props: {
            item: Object,
            question: Object
        },
        inject: ['$validator'],
        data: function() {
            if (this.item.propertyValue == null) {
                this.item.propertyValue = {
                    value: '',
                    type: {
                        kind: 'STRING'
                    }
                }
            }
        	return {
                itemValue: this.item.propertyValue,
                origEmail: this.item.propertyValue.value
        	}
        },
        watch: {
            itemValue: {
                handler: function(oldValue, newValue) {
                    this.$emit('updateValue', this.question);
                },
                deep: true
            }
        },
        mounted: function() {
            this.$validator.validate('' + this.question.id);
        },
        methods: {
            isUrl: function() {
                return this.question.propertyInfo.key.value.endsWith('.url');
            }
        }
	}
</script>


// WEBPACK FOOTER //
// ProfileEmailEditor.vue?3d17e240